export default __webpack_public_path__ + "static/caruosel-top-mobile-62417184831c45b5baee2560b9479695.jpg";